"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    animation: Boolean | Object,
    closeOnClick: Boolean,
    dataSource: Object | Array,
    direction: String,
    hoverDelay: Number,
    openOnClick: Boolean | Object,
    orientation: String,
    popupCollision: String,
    scrollable: Boolean | Object,

    // Events
    close: Function,
    open: Function,
    activate: Function,
    deactivate: Function,
    select: Function
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@progress/kendo-layout-vue-wrapper/dist/es/KendoMenu/MenuProps.js
// module id = 663
// module chunks = 0